// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3706":"a07aca43d2c9bd9f","7600":"4c3e07d8e5c33176"}[chunkId] + ".css";
};